// By Default, this is the staging environment
// It using SSR Build
export const environment = {
  production: false,
  apiUrl: 'https://stg-api.abctalkies.in/api/v1',
  productUrl: 'https://stg.abctalkies.in',
  port: 4001,
  fbAppId: '',
};
